<template>
  <div class="address">
    <span class="iconfont">&#xe614;</span>
    <div class="text">{{ address || please }}</div>
    <span bold primary>{{ $t('googlemap.change') }}</span>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      please: this.$t('googlemap.pleaseEnter'),
    };
  },
  computed: {
    ...mapState({
      address: (state) => state.Menu.addressInfo?.address3,
    }),
  },
  methods: {
    // 过滤地址详情信息
    // filterAddress(data) {
    //   const r = {};
    //   _.forEach(data.address_components, item => {
    //     // 获取国家
    //     if (item.types[0] === 'country') {
    //       r.countryName = item.long_name;
    //       if (
    //         r.countryName.indexOf('印度') >= 0 ||
    //         r.countryName.indexOf('香港') >= 0
    //       ) {
    //         r.countryName = 'Indonesia';
    //       }
    //     }
    //     // 省
    //     if (item.types[0] === 'administrative_area_level_1') {
    //       r.stateProvinceName = item.long_name;
    //     }
    //     // 城市
    //     if (item.types[0] === 'administrative_area_level_2') {
    //       r.cityName = item.long_name;
    //     }
    //     // 地区
    //     if (item.types[0] === 'administrative_area_level_3') {
    //       r.districtName = item.long_name;
    //     }
    //     // 街道
    //     if (item.types[0] === 'administrative_area_level_3') {
    //       r.subDistrictName = item.long_name;
    //     }
    //     // 编号
    //     if (item.types[0] === 'postal_code') {
    //       r.postalCode = item.long_name;
    //     }
    //   });
    //   // 如果没有地址那么就用一级地址
    //   if (!r.cityName) {
    //     r.cityName = r.stateProvinceName;
    //     r.districtName = r.stateProvinceName;
    //     r.subDistrictName = r.stateProvinceName;
    //   }
    //   // 地址3
    //   r.address3 = data.formatted_address;
    //   const { nickName, phone } = this.$store.state.Menu?.userInfo || {};
    //   // 昵称
    //   r.toName = nickName || this.$parent.user?.nickName;
    //   // 电话
    //   r.phone = phone;
    //   const { geometry = {} } = data;
    //   // 纬度
    //   r.latitude = geometry.location.lat();
    //   // 经度
    //   r.longitude = geometry.location.lng();
    //   return r;
    // },
  },
};
</script>

<style lang="scss" scoped>
.address {
  height: 30px;
  background: #fff;
  display: flex;
  line-height: 30px;
  padding: 0 8px;
  .text {
    overflow: hidden;
    text-overflow: ellipsis;
		white-space: nowrap;
		flex: 1;
		margin: 0 8px;
  }
}
</style>
